import {
  Bike,
  Dumbbell,
  Footprints,
  CircleDot,
  Zap,
  Refrigerator,
  Microwave,
  Wind,
  Droplets,
  Tv,
  Package,
  Box,
  Boxes,
  Layers,
  Grid3X3,
  LayoutGrid,
  Armchair,
  Activity,
  Home,
  Weight,
  Waves,
  type LucideIcon,
} from "lucide-react";

const CATEGORY_ICON_MAP: Record<string, LucideIcon> = {
  // Exercise Equipment - Cardio
  "treadmills": Footprints,
  "treadmill": Footprints,
  "ellipticals": CircleDot,
  "elliptical": CircleDot,
  "elliptical-trainer": CircleDot,
  "elliptical-trainers": CircleDot,
  "spin-bikes": Bike,
  "spin-bike": Bike,
  "recumbent-bikes": Armchair,
  "recumbent-bike": Armchair,
  "upright-bikes": Bike,
  "upright-bike": Bike,
  "other-bikes": Bike,
  "max-trainer": Zap,
  "max-trainers": Zap,
  "rowing-machine": Waves,
  "rowing-machines": Waves,
  "rower": Waves,
  "rowers": Waves,
  
  // Exercise Equipment - Strength
  "home-gym": Home,
  "home-gyms": Home,
  "weight-bench": Dumbbell,
  "weight-benches": Dumbbell,
  "kettlebell": Weight,
  "kettlebells": Weight,
  "strength-equipment": Dumbbell,
  "exercise-equipment": Dumbbell,
  "fitness-equipment": Dumbbell,
  
  // Appliances
  "refrigerators": Refrigerator,
  "small-appliances": Microwave,
  "air-conditioners": Wind,
  "dehumidifiers": Droplets,
  "tvs": Tv,
  "appliances": Refrigerator,
};

const FALLBACK_ICONS: LucideIcon[] = [
  Package,
  Box,
  Boxes,
  Layers,
  Grid3X3,
  LayoutGrid,
];

function normalizeSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
}

export function getCategoryIcon(categoryNameOrSlug: string): LucideIcon {
  const slug = normalizeSlug(categoryNameOrSlug);
  
  if (CATEGORY_ICON_MAP[slug]) {
    return CATEGORY_ICON_MAP[slug];
  }
  
  const index = hashString(slug) % FALLBACK_ICONS.length;
  return FALLBACK_ICONS[index];
}

export function getCategoryIconBySlug(slug: string): LucideIcon {
  if (CATEGORY_ICON_MAP[slug]) {
    return CATEGORY_ICON_MAP[slug];
  }
  
  const index = hashString(slug) % FALLBACK_ICONS.length;
  return FALLBACK_ICONS[index];
}
